import Button from '@components/Button/Button';
import { useUser } from '@context/user-context';
import { logout } from '@modules/user-helpers';
import { motion } from 'motion/react';
import Router from 'next/router';
import { useState } from 'react';

import styles from './existing-user-handler.module.scss';

interface ExistingUserHandlerProps {
  existingUserEmailAddress: string | undefined;
}

export const ExistingUserHandler: React.FC<React.PropsWithChildren<ExistingUserHandlerProps>> = ({
  existingUserEmailAddress,
}) => {
  const [signingOut, setSigningOut] = useState(false);
  const { user } = useUser();

  async function handleLoginAsNewUser() {
    setSigningOut(true);
    await logout();
    location.reload();
  }

  function goToDashboard() {
    if (!user) return;

    const currentWorkspace = user.userId; //TEMP
    Router.push(`/${currentWorkspace}/cards`);
  }

  return (
    <motion.div
      className={styles['sign-out-message-container']}
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1, transition: { duration: 0.5 } }}
    >
      <div className={styles['sign-out-message-content']}>
        <p className={styles['sign-out-message-email']}>
          You are currently logged in as <strong>{existingUserEmailAddress}</strong>.
        </p>
        <p className={styles['sign-out-message-question']}>
          Would you like to create a new account or continue to the dashboard with your current login?
        </p>
        <div className={styles['sign-out-message-btns-container']}>
          <div className={styles['sign-out-message-btn-container']}>
            <Button variant="secondary" onClick={handleLoginAsNewUser} loading={signingOut}>
              Create new account
            </Button>
          </div>
          <div className={styles['sign-out-message-btn-container']}>
            <Button variant="primary" onClick={goToDashboard}>
              Go to dashboard
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
